import { defineMessages } from 'react-intl';

const messages = defineMessages({
  emailAddress: {
    description: 'forgotPassword.emailAddress',
    defaultMessage: 'Username/Email Address',
    id: 'gvSD/F',
  },
  errorPleaseEnterYourEmail: {
    description: 'forgotPassword.errorPleaseEnterYourEmail',
    defaultMessage: 'Please enter your email address.',
    id: 'uU+4Xn',
  },
  errorUnableToCommunicateWithServer: {
    description: 'forgotPassword.errorUnableToCommunicateWithServer',
    defaultMessage: 'Unable to communicate with the server.',
    id: 'vTL2ko',
  },
  errorWhileResettingPassword: {
    description: 'forgotPassword.errorWhileResettingPassword',
    defaultMessage: 'Error while reseting password.',
    id: 'C9F9Q7',
  },
  successPasswordReset: {
    description: 'forgotPassword.successPasswordReset',
    defaultMessage: 'Password reset instructions have been sent to your email.',
    id: 'THd/gu',
  },
  returnToLogin: {
    description: 'forgotPassword.login',
    defaultMessage: 'Return to Log In',
    id: 'U5IfHP',
  },
  createAnAccount: {
    description: 'forgotPassword.createAnAccount',
    defaultMessage: 'Create an account',
    id: 'txZ4K+',
  },
  sendResetLink: {
    description: 'forgotPassword.sendResetLink',
    defaultMessage: 'Send Reset Link',
    id: 'DMP769',
  },
  emailInstructions: {
    description: 'forgotPassword.instructions',
    defaultMessage: 'We will email you a reset password link',
    id: 'TiujEY',
  },
  resetPassword: {
    description: 'forgotPassword.title',
    defaultMessage: 'Reset Password',
    id: 'OR6Vs7',
  },
});

export default messages;
